import { render, staticRenderFns } from "./domesticForm.vue?vue&type=template&id=7b512c89&scoped=true&"
import script from "./domesticForm.vue?vue&type=script&lang=js&"
export * from "./domesticForm.vue?vue&type=script&lang=js&"
import style0 from "./domesticForm.vue?vue&type=style&index=0&id=7b512c89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b512c89",
  null
  
)

export default component.exports